module.exports = __webpack_public_path__ + "media/packs/images/flags/MX-48f06f43813451171b89fc6c63a9d1aa.svg";